import { HTTPResponse, FreeDropClaim, FreeDropPlayerCollectedAmount, FreeDropClaimResponse } from '../../../models';
import { BaseApiService } from '../../base-api-service';
import { ApiVersions } from '../../../enums';
import { env } from '../../../environment';

class FreeDropController extends BaseApiService {

  public async getPlayerProgress(freeDropId: number): Promise<FreeDropPlayerCollectedAmount> {
    const url = `${this.url}/free-drop/api/${ApiVersions.V1}/campaigns/${freeDropId}/progress`;
    return await this.http.get(url);
  }

  public async claim(payload: FreeDropClaim): Promise<HTTPResponse<FreeDropClaimResponse>> {
    const url = `${this.url}/free-drop/api/${ApiVersions.V1}/campaigns/prizes/claim`;
    return await this.http.post(url, payload, { skipInterceptor: true });
  }

}

export const freeDropController = new FreeDropController({ url: env.origin });
